var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('homePopup'),_c('Banner'),_c('mobileBanner'),_c('PremiumListing'),_c('CategoryBlock'),_c('LatestProperties'),_c('BaseInfo'),_c('ByLocation'),_c('DirectAction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }